import { toValue } from "vue";
import type { MaybeRefOrGetter } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

export function useDirty(dirtyId: MaybeRefOrGetter<string>) {
  const store = useStore();
  const { t } = useI18n();

  // getters
  const isDirty = (id: string) => store.getters["app/getPageDirty"](id);

  const isComponentDirty = () => isDirty(toValue(dirtyId));

  const checkWholePageDirty = () => store.getters["app/checkWholePageDirty"];

  // actions
  function setDirty(id: string) {
    store.dispatch("app/addPageDirty", id);
  }
  function removeDirty(id: string) {
    store.dispatch("app/removePageDirty", id);
  }
  function removeComponentDirty() {
    removeDirty(toValue(dirtyId));
  }
  function clearDirty() {
    store.dispatch("app/clearPageDirty");
  }

  // prompts
  async function promptPageDirty(): Promise<boolean> {
    if (!checkWholePageDirty()) return true;
    const ok = window.confirm(t("dirty_confirmation_prompt"));
    if (!ok) return false;
    clearDirty();
    return true;
  }

  async function promptComponentDirty(): Promise<boolean> {
    if (!isComponentDirty()) return true;
    const ok = window.confirm(t("dirty_confirmation_prompt"));
    if (!ok) return false;
    removeComponentDirty();
    return true;
  }

  return {
    // getters
    isDirty,
    isComponentDirty,
    checkWholePageDirty,

    // actions
    setDirty,
    removeDirty,
    removeComponentDirty,
    clearDirty,

    // prompts
    promptPageDirty,
    promptComponentDirty,
  };
}
